module.exports = require("request-promise");